import { Box, Text } from '@factorialco/deprecated-design-system'
import { Moment } from 'moment'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import ContractTooltip from 'modules/contracts/components/ContractDetails/ContractTooltip'
import { calculateDateDifference } from 'modules/contracts/lib/contractDates'

interface Props {
  startDate?: Moment | null
}

const StartDate = ({ startDate }: Props) => {
  const { years, months, days, isPast } = startDate
    ? calculateDateDifference(startDate)
    : { years: 0, months: 0, days: 0, isPast: false }
  const formattedStartDate = startDate ? dateToString(startDate, 'ui_dmy_long') : null
  const tooltipInformation = isPast
    ? i18n.t('contract_versions.contract_information.start_date_tooltip_past', {
        startDate: formattedStartDate,
      })
    : i18n.t('contract_versions.contract_information.start_date_tooltip_future', {
        startDate: formattedStartDate,
      })
  const tenureYears =
    years > 0
      ? i18n.tp('contract_versions.fix_discontinuous.activity_start.tenure.years', { count: years })
      : ''
  const tenureMonths =
    months > 0
      ? i18n.tp('contract_versions.fix_discontinuous.activity_start.tenure.months', {
          count: months,
        })
      : ''
  const tenureDays =
    days > 0
      ? i18n.tp('contract_versions.fix_discontinuous.activity_start.tenure.days', { count: days })
      : ''
  const tenure = [tenureYears, tenureMonths, tenureDays].filter(Boolean).join(', ')

  return (
    <Box gridColSpan={{ xxs: 12, xs: 6, s: 3 }} gap="s2">
      <Box gap="s8">
        <Box flexDirection="row" alignItems="center" gap="s4" height="s24">
          <Text size="200" weight="normal" color="grey800">
            {i18n.t('contract_versions.contract_information.start_date')}
          </Text>
          {startDate && (
            <ContractTooltip information={tooltipInformation} icon="info-circle-line" />
          )}
        </Box>
        {startDate && (
          <Text size="300" weight="medium" color="grey1000">
            {formattedStartDate}
          </Text>
        )}
        {!startDate && (
          <Text size="300" weight="medium" color="grey600">
            {i18n.t('contract_versions.contract_information.not_informed')}
          </Text>
        )}
      </Box>
      <Text size="200" weight="normal" color="grey800">
        {tenure}
      </Text>
    </Box>
  )
}

export default StartDate
